import script from "./ServersFleetBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./ServersFleetBoard.vue?vue&type=script&setup=true&lang=js"

import "./ServersFleetBoard.vue?vue&type=style&index=0&id=a9071d24&lang=scss"

const __exports__ = script;

export default __exports__